import type { IScheduledQuotesBlotterItem } from 'apiConnector/scheduledRun/scheduledQuotesBlotter';
import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import type { SchedulePanelTab } from 'state/blotters/scheduledQuotes';
import {
  getEditableScheduledRun,
  getSelectedPanelTab,
  scheduledQuotesBlotterPanelClosedThunk,
  scheduledQuotesBlotterPanelTabChangedThunk,
} from 'state/blotters/scheduledQuotes';
import { scheduledQuotesBlotter } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { LoadingStatus } from 'utils/status';

interface StateProps extends IScheduledQuotesBlotterItem {
  selectedPanelTab: SchedulePanelTab;

  updateStatus: LoadingStatus;
}

interface DispatchProps {
  onClosed: () => void;

  selectPanelTab: (tab: SchedulePanelTab) => void;
}

export type ScheduledQuotesBlotterPanelProps = StateProps & DispatchProps;

const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (state: AppState): StateProps => {
  return {
    ...scheduledQuotesBlotter.getSelectedItem(state)!,
    selectedPanelTab: getSelectedPanelTab(state),
    updateStatus: getEditableScheduledRun(state).updateRun.status,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => {
  return {
    onClosed() {
      dispatch(scheduledQuotesBlotterPanelClosedThunk());
    },
    selectPanelTab(tab) {
      dispatch(scheduledQuotesBlotterPanelTabChangedThunk(tab));
    },
  };
};

export const connectScheduledQuotesBlotterPanel = connect(mapStateToProps, mapDispatchToProps);
